import { mapGetters, mapState } from 'vuex';

import { GuidelineUserRoles, GuidelineUserRolesStatus } from '@/lib/guideline';

import { 
  GUIDELINE_USER_ROLE_ACCEPT,
  GUIDELINE_USER_ROLE_REJECT,
  GUIDELINE_USER_ROLE_CHANGE_REQUEST
} from '@/store/actions/guideline_user_role'

export default {
  name: 'role-acceptance',
  components: {},
  props: ['guideline'],
  data () {
    return {
      showChangeInfo : false,
      changeRequest : null,
      GuidelineUserRoles : GuidelineUserRoles,
      GuidelineUserRolesStatus : GuidelineUserRolesStatus,
    }
  },
  computed: {
    ...mapState({
      dataLoading: state => state.guideline_user_role.status === 'loading',
      dataError: state => state.guideline_user_role.status === 'error',
    }),
    ...mapGetters([
      'getUserData',
    ]),

    userRoles() {
      let roles = new Array;
      let {co_author_ids, cowrite_user_ids, review_user_ids} = this.guideline;

      co_author_ids = JSON.parse(JSON.stringify(co_author_ids));
      cowrite_user_ids = JSON.parse(JSON.stringify(cowrite_user_ids));
      review_user_ids = JSON.parse(JSON.stringify(review_user_ids));

      if (co_author_ids.length > 0) {
        let coa = (co_author_ids.filter(elem => { return elem.value == this.getUserData.id})).pop();
        if (coa != undefined) {
          roles.push(coa);
        }
      }

      if (cowrite_user_ids.length > 0) {
        let cow = (cowrite_user_ids.filter(elem => { return elem.value == this.getUserData.id})).pop();
        if (cow != undefined) {
          roles.push(cow);
        }
      }

      if (review_user_ids.length > 0) {
        let rew = (review_user_ids.filter(elem => { return elem.value == this.getUserData.id})).pop();
        if (rew != undefined) {
          roles.push(rew);
        }
      }

      return roles;
    },
  },
  mounted () {
  },
  methods: {
    userRole(role) {
      let label = '';

      switch (role) {
        case GuidelineUserRoles.coauthor:
          label = this.$t('message.Guideline.RoleAcceptance.roles.' + role);
          break;
        case GuidelineUserRoles.cowriter:
          label = this.$t('message.Guideline.RoleAcceptance.roles.' + role);
          break;
        case GuidelineUserRoles.reviewer:
          label = this.$t('message.Guideline.RoleAcceptance.roles.' + role);
          break;
      }

      return label;
    },

    requestedRole(role) {
      let roleLabel;
      
      switch (role.change_request) {
        case GuidelineUserRoles.coauthor:
          roleLabel = this.$t('message.Guideline.RoleAcceptance.roles.' + role.change_request);
          break;
        case GuidelineUserRoles.cowriter:
          roleLabel = this.$t('message.Guideline.RoleAcceptance.roles.' + role.change_request);
          break;
        case GuidelineUserRoles.reviewer:
          roleLabel = this.$t('message.Guideline.RoleAcceptance.roles.' + role.change_request);
          break;
      }

      return roleLabel;
    },

    acceptInfo(role){
      this.$swal({
        title: this.$t("message.areYouSure"),
        text: this.$t("message.Guideline.RoleAcceptance.acceptWarning"),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("message.yes"),
        cancelButtonText: this.$t("message.noCancel"),
      }).then((result) => {
        if (result.value) {
          return this.accept(role);
        }
      });
    },

    accept(role) {
      this.$store.dispatch(GUIDELINE_USER_ROLE_ACCEPT, {guideline: this.guideline, role: role}).then((response) => {
        this.$swal({
          title: this.$t("message.success"),
          text: this.$t("message.Guideline.RoleAcceptance.roleWasAccepted"),
          type: 'success',
        });

        this.$emit('refreshGuidelineData');
      }).catch((error) => {
          this.handleUnauth(error.response.status);
      });
    },

    rejectInfo(role){
      this.$swal({
        title: this.$t("message.areYouSure"),
        text: this.$t("message.Guideline.RoleAcceptance.rejectWarning"),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("message.yes"),
        cancelButtonText: this.$t("message.noCancel"),
        input: 'textarea',
        inputPlaceholder: this.$t('message.Guideline.RoleAcceptance.rejectTextboxPlaceholder'),
      }).then((result) => {
        if (result.value) {
          return this.reject(role, result.value);
        }
      });
    },

    reject(role, comment) {
      this.$store.dispatch(GUIDELINE_USER_ROLE_REJECT, { guideline: this.guideline, comment: comment, role: role }).then((response) => {
        this.$swal({
          title: this.$t("message.success"),
          text: this.$t("message.Guideline.RoleAcceptance.roleWasRejected"),
          type: 'success',
        });

        this.$emit('refreshGuidelineData');
      }).catch((error) => {
          this.handleUnauth(error.response.status);
      });
    },

    submitChangeRoleRequest(role){
      this.$swal({
        title: this.$t("message.areYouSure"),
        text: this.$t("message.Guideline.RoleAcceptance.changeWarning"),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("message.yes"),
        cancelButtonText: this.$t("message.noCancel"),
        input: 'textarea',
        inputPlaceholder: this.$t('message.Guideline.RoleAcceptance.changeTextboxPlaceholder'),
      }).then((result) => {      
        if (result.value != undefined) {
          this.change(role, result.value);
        }
      });
    },

    change(role, comment) {
      this.$store.dispatch(GUIDELINE_USER_ROLE_CHANGE_REQUEST, { guideline: this.guideline, comment: comment, changeRequest: this.changeRequest, role: role }).then((response) => {
        this.$swal({
          title: this.$t("message.success"),
          text: this.$t("message.Guideline.RoleAcceptance.changeRequestWasSend"),
          type: 'success',
        });

        this.$emit('refreshGuidelineData');
      }).catch((error) => {
          this.handleUnauth(error.response.status);
      });
    },

    changeRoleOptions(role) {
      return [
        { text: this.$t('message.Guideline.RoleAcceptance.roles.' + GuidelineUserRoles.coauthor ) , value: GuidelineUserRoles.coauthor, disabled: role == GuidelineUserRoles.coauthor },
        { text: this.$t('message.Guideline.RoleAcceptance.roles.' + GuidelineUserRoles.cowriter ) , value: GuidelineUserRoles.cowriter, disabled: role == GuidelineUserRoles.cowriter },
        { text: this.$t('message.Guideline.RoleAcceptance.roles.' + GuidelineUserRoles.reviewer ) , value: GuidelineUserRoles.reviewer, disabled: role == GuidelineUserRoles.reviewer },
      ];
    }
  }
}
